import * as yup from "yup";

export const CRACreditSetupValidationSchema = yup.object().shape({
	date: yup.string().required("Date is required"),
	amount: yup.string().required("Amount is required"),
	period: yup.string().required("Period is required"),
});
